module.exports = __webpack_public_path__ + "static/media/3-mobile.0ce9041f.jpg";